import { Component, OnInit } from "@angular/core";
import ApolloClient from "apollo-boost";
import gql from "graphql-tag";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: "query-test",
    templateUrl: "./query.test.component.html",
    styleUrls: ["./query.test.component.css"]
  })
  
  export class QueryTestComponent implements OnInit{
      
      queryText: string = "Query";
      parameterText: string = "{}";
      queryResultText: string = "";
      showLoader: boolean = false;
      client = new ApolloClient({
        uri: "https://www.ch4mundi.net/GraphQLBackend/graphql"
      });

      queryMap : Map<string, string> = new Map<string, string>();
      parameterMap : Map<string, string> = new Map<string, string>();

      constructor(private spinner: NgxSpinnerService) { 
        this.queryMap.set("Alle Vereine", "query allevereine { allevereine  { name } }");
        this.queryMap.set("Einzelverein", "query einzelverein ($Id: Int!){ einzelverein(id: $Id) { name } }");
        this.queryMap.set("Spieltag einer Saison", "query spieltag ($saison: Int!, $spieltagnr: Int! ) { spieltag(saison: $saison, spieltagnr: $spieltagnr) { nummer datum saison spiele { heimVerein gastVerein heimTore gastTore } } }");
        this.queryMap.set("Vereine einer Saison", "query saisonvereine ($saisonendjahr: Int!){ saisonvereine(saisonendjahr: $saisonendjahr) { name } }");
        this.queryMap.set("Alle Saisons", "query allesaisons { allesaisons  { endYear } }");
        this.queryMap.set("Einzelsaison", "query einzelsaison ($saisonendjahr: Int!){ einzelsaison(saisonendjahr: $saisonendjahr) { endYear } }");
        this.queryMap.set("Anzahl der Spieltage einer Saison", "query saisonmetadata ($saisonendjahr: Int!){ saisonmetadata(saisonendjahr: $saisonendjahr) { maxSpieltagAnzahlSaison } }");
        this.queryMap.set("Spieltag Tabelle einer Saison", "query saisontabelle ($saison: Int!, $spieltagnr: Int!) { saisontabelle(saison: $saison, spieltagnr: $spieltagnr) { verein { name } spielAnzahl siege remis niederlagen toreErzielt toreGefangen punkte anzahlHeimSpiele heimSiege heimRemis heimNiederlagen heimToreErzielt heimToreGefangen heimPunkte anzahlGastSpiele gastSiege gastRemis gastNiederlagen gastToreErzielt gastToreGefangen gastPunkte } }");
        this.queryMap.set("Ewige Tabelle", "query historytabelle  { historytabelle { verein { name } spielAnzahl siege remis niederlagen toreErzielt toreGefangen punkte anzahlHeimSpiele heimSiege heimRemis heimNiederlagen heimToreErzielt heimToreGefangen heimPunkte anzahlGastSpiele gastSiege gastRemis gastNiederlagen gastToreErzielt gastToreGefangen gastPunkte } }");

        this.parameterMap.set("Einzelverein", "{ \"Id\" : 50 }");
        this.parameterMap.set("Spieltag einer Saison", "{ \"saison\" : 2018, \"spieltagnr\" : 34 }");
        this.parameterMap.set("Vereine einer Saison", "{ \"saisonendjahr\" : 2018 }");
        this.parameterMap.set("Einzelsaison", "{ \"saisonendjahr\" : 2018 }");
        this.parameterMap.set("Anzahl der Spieltage einer Saison", "{ \"saisonendjahr\" : 2018 }");
        this.parameterMap.set("Spieltag Tabelle einer Saison", "{ \"saison\" : 2018, \"spieltagnr\" : 34 }");
      }

      public onChange(event): void {
        this.queryText = this.queryMap.get(event.target.value);
        this.parameterText = this.parameterMap.has(event.target.value) ? this.parameterMap.get(event.target.value) : "{}";
      }

      //TODO: Ist das eine gute Idee ?
      getKeys(){
        return Array.from(this.queryMap.keys());
      }

      getValues(): any{
        return Array.from(this.queryMap.values());
      }

      ngOnInit() {
        this.queryText = this.queryMap.get("Alle Vereine");
        //this.vereinsListe = this.apollo.watchQuery({
        //  query: "query { allevereine { name } }"
        //}).valueChanges.pipe(map(result => result));
  
        //.valueChanges.pipe(map(result => result.data && result.data.allevereine));
      }
  
      queryServer() : void {
          this.spinner.show();
          const query = gql(this.queryText);
          this.client.query({
          query: query,
          variables: JSON.parse(this.parameterText)
        }).then(result => {
          this.queryResultText = JSON.stringify(result, null, 5);
          this.spinner.hide();
        });
      }
  }